import { memo } from 'react';
import { Plus, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ILeadsPageHeaderProps } from '@/@types/leads';

export const LeadsPageHeader = memo(function LeadsPageHeader({
  totalCount,
  onExport,
  onAddLead,
}: ILeadsPageHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6">
      {/* Left side - Title and count */}
      <div className="flex items-center gap-4">
        <h1 className="text-[28px] font-bold text-foreground">Leads</h1>
        <span className="inline-flex items-center px-2.5 py-1 rounded-xl text-[13px] font-medium bg-lead-count-badge-bg text-lead-count-badge">
          {totalCount} leads
        </span>
      </div>

      {/* Right side - Actions */}
      <div className="flex items-center gap-3">
        <Button variant="ghost" onClick={onExport} className="gap-2">
          <Download className="w-4 h-4" />
          Export
        </Button>
        <Button onClick={onAddLead} className="gap-2 rounded-xl">
          <Plus className="w-4 h-4" />
          Add Lead
        </Button>
      </div>
    </div>
  );
});
